import * as React from "react";

export const Worker = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 8C6.09821 8 4.57143 6.44141 4.57143 4.5C4.57143 2.58594 6.09821 1 8 1C9.875 1 11.4286 2.58594 11.4286 4.5C11.4286 6.44141 9.875 8 8 8ZM10.5446 8.90234C12.4732 8.98438 14 10.5977 14 12.5664V13.6875C14 14.4258 13.4107 15 12.7143 15H3.28571C2.5625 15 2 14.4258 2 13.6875V12.5664C2 10.5977 3.5 8.98438 5.42857 8.90234L6.71429 14.125L7.57143 10.4062L6.71429 8.875H9.28571L8.42857 10.4062L9.28571 14.125L10.5446 8.90234Z"
    />
);
